<template>
  <v-layout
    align-center
    wrap
  >
    <v-flex
      xs12
      class="mt-4"
    >
      <v-layout>
        <v-flex
          class="mt-4 mr-2"
          :shrink="lgAndUp"
        >
          <span class="fw-600 f-2 text-dark">{{ indexNum(index) }}</span>
        </v-flex>
        <v-flex>
          <v-layout wrap>
            <v-flex
              v-for="(item, i) in footwear"
              :key="i"
              xs12
              :class="[{ 'personal-form_bordered': completes[i] }]"
            >
              <v-layout align-center>
                <v-flex>
                  <v-layout wrap>
                    <v-flex lg4>
                      <v-text-field
                        :label="$t('sheet.sheet_two.clothing.labels.name')"
                        class="ml-1 personal-input_disabled"
                        :value="newName"
                        disabled
                      />
                    </v-flex>
                    <v-flex lg4>
                      <v-autocomplete
                        v-model="item.category"
                        v-validate="{
                          required: chosenFootwearDetails.chosen_list.category.required
                        }"
                        :label="chosenFootwearDetails.chosen_list.category.label"
                        append-icon="keyboard_arrow_down"
                        class="ml-1"
                        :class="{ 'ml-2': lgAndUp }"
                        :items="footwearCategory"
                        item-value="id"
                        item-text="description"
                        :error-messages="
                          errors.collect(createDataName('footwearCategory', i, index))
                        "
                        :data-vv-as="$t('sheet.sheet_two.clothing.labels.category')"
                        :data-vv-name="createDataName('footwearCategory', i, index)"
                        :required="chosenFootwearDetails.chosen_list.category.required"
                        :disabled="readOnly"
                        @blur="completePersonData(i)"
                        @focus="falseComplete(i)"
                      />
                    </v-flex>
                    <v-flex lg4>
                      <v-autocomplete
                        v-model="item.size"
                        v-validate="{ required: chosenFootwearDetails.chosen_list.size.required }"
                        :label="chosenFootwearDetails.chosen_list.size.label"
                        append-icon="keyboard_arrow_down"
                        class="ml-1"
                        :class="{ 'ml-2': lgAndUp }"
                        :items="footwearSizes"
                        item-value="id"
                        item-text="description"
                        :error-messages="errors.collect(createDataName('footwearSize', i, index))"
                        :data-vv-as="$t('sheet.sheet_two.clothing.labels.size')"
                        :data-vv-name="createDataName('footwearSize', i, index)"
                        :required="chosenFootwearDetails.chosen_list.size.required"
                        :disabled="readOnly"
                        @blur="completePersonData(i)"
                        @focus="falseComplete(i)"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="item.note"
                        v-validate="{
                          ...requiredRegularField(chosenFootwearDetails.chosen_list.note.required)
                        }"
                        :label="chosenFootwearDetails.chosen_list.note.label"
                        :error-messages="errors.collect(createDataName('footwearNote', i, index))"
                        :data-vv-as="$t('sheet.sheet_two.clothing.labels.note')"
                        :data-vv-name="createDataName('footwearNote', i, index)"
                        :placeholder="item.complete ? '-' : $t('sheet.enter_text')"
                        :disabled="readOnly"
                        :rows="1"
                        auto-grow
                        @blur="completePersonData(i)"
                        @focus="falseComplete(i)"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex shrink>
                  <a
                    :disabled="!isCurrentEdition || readOnly"
                    @click="removeClothes(i)"
                  >
                    <BaseIcon class="clickable ml-2 mt-1">
                      <CartIcon :icon-color="$vuetify.theme.sz_grey" />
                    </BaseIcon>
                  </a>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <a
                class="link_iconed"
                :disabled="!isCurrentEdition || readOnly"
                @click="addClothes()"
              >
                <v-icon>add</v-icon> {{ $t('sheet.sheet_two.clothing.add_footwear_btn') }}</a>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import validationRules from '@/constants/validationRules';

import CartIcon from '@/icons/CartIcon';
import BaseIcon from '@/icons/BaseIcon';

import sheetResourcesGetter from '@/mixins/sheet/sheetResourcesGetter';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';

export default {
    name: 'FootwearForm',
    components: { CartIcon, BaseIcon },
    mixins: [sheetResourcesGetter, sheetValidationRules],
    inject: ['$validator'],
    props: {
        member: {
            type: Object,
            default: () => {
                return {};
            }
        },
        newName: {
            type: String,
            default: ''
        },
        index: {},
        readOnly: {
            default: false,
            type: Boolean
        },
        chosenFootwearDetails: {
            default: null
        }
    },
    data () {
        return {
            mutableMember: this.member,
            validationRules,
            footwearData: {
                category: null,
                size: null,
                note: ''
            },
            completes: [],
            footwear: []
        };
    },
    computed: {
        lgAndUp () {
            return this.$vuetify.breakpoint.lgAndUp;
        },
        footwearCategory () {
            return this.getSheetTwoResources(this.chosenFootwearDetails.chosen_list.category);
        },
        footwearSizes () {
            return Array.from({ length: 39 }, (v, k) => 14 + k);
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        }
    },
    watch: {
        'member.chosenList': {
            handler (val) {
                this.footwear = val;
                if (this.completes.length < val.length) {
                    this.completes.push(false);
                }
            },
            immediate: true
        }
    },
    created () {
        if (this.mutableMember.chosenList.length === 0) {
            this.mutableMember.chosenList.push({ ...this.footwearData });
            this.mutableMember.chosenList.forEach(() => {
                this.completes.push(false);
            });
        }
        this.footwear = this.mutableMember.chosenList;
    },
    methods: {
        indexNum (index) {
            return index + 1 + '.';
        },
        createDataName (name, i, index) {
            return name + i + index;
        },
        addClothes () {
            if (this.readOnly === true) {
                return;
            }
            this.$set(this.mutableMember.chosenList, this.mutableMember.chosenList.length, {
                ...this.footwearData
            });
        },
        removeClothes (i) {
            if (this.readOnly === true) {
                return;
            }
            if (this.mutableMember.chosenList.length > 1) {
                this.mutableMember.chosenList.splice(i, 1);
                this.completes.splice(i, 1);
            } else {
                this.mutableMember.chosenList[0].type = null;
                this.mutableMember.chosenList[0].category = null;
                this.mutableMember.chosenList[0].size = null;
                this.mutableMember.chosenList[0].note = '';
                this.completes[0] = false;
            }
        },
        completePersonData (i) {
            this.mutableMember.chosenList.forEach((el, index) => {
                if (index === i) {
                    const _keys = [];
                    Object.keys(this.fields).forEach((key) => {
                        if (key.indexOf(i) !== -1) {
                            _keys.push(this.fields[key]);
                        }
                    });
                    this.completes[i] = Object.keys(_keys).every((key) => _keys[key].valid);
                }
            });
        },
        falseComplete (index) {
            this.completes[index] = false;
        }
    }
};
</script>

<style scoped></style>
